import { createRouter, createWebHistory } from 'vue-router';
import HelloWorld from '../components/HelloWorld.vue';
import Calendario from '../components/Calendario.vue';
import CalendarioVacaciones from '../components/CalendarioVacaciones.vue';
import Comunidades from '../components/Comunidades.vue';
import CrearProyectoComunidad from '../components/CrearProyectoComunidad.vue';
import IngresosGastos from '../components/IngresosGastos.vue';
import CargaComparativaGastosContasol from '../components/CargaComparativaGastosContasol.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HelloWorld,
  },
  {
    path: '/calendario/:username',  // Añadido parámetro dinámico
    name: 'Calendario',
    component: Calendario,
  },
  {
    path: '/calendario-vacaciones',  // Añadido parámetro dinámico
    name: 'CalendarioVacaciones',
    component: CalendarioVacaciones,
  },
  {
    path: '/comunidades',  // Añadido parámetro dinámico
    name: 'Comunidades',
    component: Comunidades,
  },
  {
    path: '/crear-proyecto-comunidad',  // Añadido parámetro dinámico
    name: 'CrearProyectoComunidad',
    component: CrearProyectoComunidad,
  },
  {
    path: '/ingresos-gastos',  // Añadido parámetro dinámico
    name: 'IngresosGastos',
    component: IngresosGastos,
  },
  {
    path: '/carga-fichero-contasol',  // Añadido parámetro dinámico
    name: 'CargaComparativaGastosContasol',
    component: CargaComparativaGastosContasol,
  },
  // Puedes agregar más rutas aquí
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

export default router;